import { render, staticRenderFns } from "./DingBu.vue?vue&type=template&id=76fbb900&"
import script from "./DingBu.vue?vue&type=script&lang=js&"
export * from "./DingBu.vue?vue&type=script&lang=js&"
import style0 from "./DingBu.vue?vue&type=style&index=0&id=76fbb900&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports